import { useAuth } from "../lib/auth";
import { ArrowCounterClockwise, Sparkle, SignOut } from "@phosphor-icons/react";

const LOGO_URL = "https://customer-assets.emergentagent.com/wingman/52592614-2f6e-41de-a2fc-8bd4fa178175/attachments/a7b256c6c0d7412eaeb7f8471465bdc5_Dise_o sin t_tulo.png";

const Sparkles = () => {
  const items = [
    { top: "8%", left: "12%", size: 16, delay: 0, dur: 4 },
    { top: "22%", left: "82%", size: 22, delay: 1.2, dur: 5 },
    { top: "70%", left: "8%", size: 14, delay: 0.6, dur: 3.5 },
    { top: "85%", left: "78%", size: 18, delay: 1.8, dur: 4.5 },
    { top: "45%", left: "92%", size: 12, delay: 2.4, dur: 4 },
    { top: "55%", left: "3%", size: 20, delay: 0.3, dur: 5 },
  ];
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {items.map((s, i) => (
        <Sparkle
          key={i}
          size={s.size}
          weight="fill"
          className="absolute text-turquoise/40"
          style={{
            top: s.top,
            left: s.left,
            animation: `floatTwinkle ${s.dur}s ease-in-out ${s.delay}s infinite`,
          }}
        />
      ))}
    </div>
  );
};

export default function Pending() {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen relative overflow-hidden flex items-center justify-center px-4">
      {/* Animated gradient bg */}
      <div
        className="absolute inset-0 z-0"
        style={{
          background:
            "radial-gradient(ellipse at 30% 20%, rgba(0,176,255,0.18) 0%, transparent 50%), radial-gradient(ellipse at 70% 80%, rgba(0,255,212,0.14) 0%, transparent 50%), #050505",
        }}
      />
      {/* Grid pattern */}
      <div
        className="absolute inset-0 z-0 opacity-20"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />
      <Sparkles />

      <style>{`
        @keyframes floatY {
          0%, 100% { transform: translateY(0px) rotate(-2deg); }
          50% { transform: translateY(-14px) rotate(2deg); }
        }
        @keyframes floatTwinkle {
          0%, 100% { opacity: 0.15; transform: scale(0.8) rotate(0deg); }
          50% { opacity: 0.9; transform: scale(1.2) rotate(180deg); }
        }
        @keyframes glowPulse {
          0%, 100% { box-shadow: 0 0 30px rgba(0, 255, 212, 0.25), 0 0 60px rgba(0, 176, 255, 0.15); }
          50% { box-shadow: 0 0 50px rgba(0, 255, 212, 0.55), 0 0 100px rgba(0, 176, 255, 0.35); }
        }
        @keyframes ringSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes wave {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(14deg); }
          75% { transform: rotate(-8deg); }
        }
      `}</style>

      <div className="relative z-10 w-full max-w-md" data-testid="pending-screen">
        {/* Logo with animations */}
        <div className="relative w-40 h-40 mx-auto mb-8">
          {/* Spinning ring */}
          <div
            className="absolute inset-[-12px] rounded-full border-2 border-dashed border-turquoise/30"
            style={{ animation: "ringSpin 18s linear infinite" }}
          />
          {/* Glow halo */}
          <div
            className="absolute inset-0 rounded-full"
            style={{ animation: "glowPulse 3s ease-in-out infinite" }}
          />
          {/* Floating logo (cropped circular) */}
          <div
            className="relative w-40 h-40 rounded-full overflow-hidden border border-turquoise/30"
            style={{ animation: "floatY 4s ease-in-out infinite" }}
          >
            <img
              src={LOGO_URL}
              alt="CRIYE"
              className="w-full h-full object-cover scale-110"
              style={{ background: "transparent" }}
            />
          </div>
        </div>

        {/* Message card */}
        <div className="glass-card rounded-2xl p-8 backdrop-blur-xl">
          <div className="text-center mb-5">
            <span className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.25em] text-turquoise mb-3">
              <Sparkle size={12} weight="fill" /> Acceso restringido <Sparkle size={12} weight="fill" />
            </span>
            <h1 className="text-3xl font-heading font-bold text-white mb-3">
              ¡Ups! Todavía no sos parte del{" "}
              <span className="text-brand-gradient">Team CRIYE</span>...{" "}
              <span
                className="inline-block origin-[70%_70%]"
                style={{ animation: "wave 2.5s ease-in-out infinite" }}
              >
                💥
              </span>
            </h1>
          </div>

          <div className="bg-gradient-to-br from-turquoise/[0.08] to-cyanBrand/[0.05] border border-turquoise/20 rounded-xl p-5 mb-6">
            <p className="text-sm text-zinc-300 leading-relaxed mb-3">
              ¡Pero no te desanimes! El camino al team se hace sumando. Visitanos más de seguido para poder ser parte; tené en cuenta que mientras más compres en{" "}
              <a
                href="https://www.criye.ar"
                target="_top"
                rel="noopener"
                className="font-mono text-turquoise hover:text-white underline underline-offset-2 decoration-turquoise/40"
              >
                www.criye.ar
              </a>
              , tenés más chances de subir de nivel y ganarte tu lugar.
            </p>
            <p className="text-sm text-white font-medium mt-4">
              🛒 ¿Qué estás esperando para armar tu próximo carrito?
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <a
              href="https://www.criye.ar"
              target="_top"
              rel="noopener"
              data-testid="pending-visit-store-btn"
              className="w-full flex items-center justify-center gap-2 bg-brand-gradient text-black font-semibold py-3 rounded-md hover:opacity-90 transition text-sm shadow-cyan-glow"
            >
              🛒 Ir a la tienda
            </a>
            <div className="flex gap-2">
              <button
                onClick={() => window.location.reload()}
                data-testid="pending-refresh-btn"
                className="flex-1 flex items-center justify-center gap-2 bg-white/5 border border-turquoise/30 text-turquoise py-2.5 rounded-md hover:bg-turquoise/10 transition text-xs font-mono uppercase tracking-wider"
              >
                <ArrowCounterClockwise size={14} weight="bold" /> Ya me registraron
              </button>
              <button
                onClick={logout}
                data-testid="pending-logout-btn"
                className="flex items-center justify-center gap-1.5 bg-white/5 border border-white/10 text-zinc-300 px-4 py-2.5 rounded-md hover:bg-white/10 transition text-xs font-mono uppercase tracking-wider"
              >
                <SignOut size={12} /> Salir
              </button>
            </div>
          </div>

          {user?.email && (
            <p className="text-[10px] text-zinc-600 mt-5 font-mono text-center break-all">
              {user.email}
            </p>
          )}
        </div>

        <p className="text-center text-[10px] text-zinc-600 mt-6 font-mono tracking-wider">
          CRIYE · REPUESTOS Y ACCESORIOS PARA CELULARES
        </p>
      </div>
    </div>
  );
}
